import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: {
    // Exercise num
    unit: "Unit 1",
    id: "SB3-U1-P10-E1",
    audio: "img/FriendsPlus/Page10/Audio/audio-e1-p10.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page10/E1/1.jpg" },
        { url: "img/FriendsPlus/Page10/E1/2.jpg", audioUrl: "img/FriendsPlus/Page10/Audio/tieude-e1-p10.mp3", },
        { url: "img/FriendsPlus/Page10/E1/3.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page10/E1/4.jpg" }],
      [
        // Column3
        { url: "img/FriendsPlus/Page10/E1/5.jpg" },
        { url: "img/FriendsPlus/Page10/E1/6.jpg", audioUrl: "img/FriendsPlus/Page10/Audio/11.mp3", },
        { url: "img/FriendsPlus/Page10/E1/7.jpg" },
        { url: "img/FriendsPlus/Page10/E1/8.jpg", audioUrl: "img/FriendsPlus/Page10/Audio/12.mp3", },
        { url: "img/FriendsPlus/Page10/E1/9.jpg" },
        { url: "img/FriendsPlus/Page10/E1/10.jpg", audioUrl: "img/FriendsPlus/Page10/Audio/13.mp3", },
        { url: "img/FriendsPlus/Page10/E1/11.jpg" },
        { url: "img/FriendsPlus/Page10/E1/12.jpg", audioUrl: "img/FriendsPlus/Page10/Audio/14.mp3", },
        { url: "img/FriendsPlus/Page10/E1/13.jpg" },
        { url: "img/FriendsPlus/Page10/E1/14.jpg", audioUrl: "img/FriendsPlus/Page10/Audio/15.mp3", },
        { url: "img/FriendsPlus/Page10/E1/15.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page10/E1/16.jpg" }],
      [
        // Column5
        { url: "img/FriendsPlus/Page10/E1/17.jpg" },
        { url: "img/FriendsPlus/Page10/E1/18.jpg", audioUrl: "img/FriendsPlus/Page10/Audio/16.mp3", },
        { url: "img/FriendsPlus/Page10/E1/19.jpg" },
        { url: "img/FriendsPlus/Page10/E1/20.jpg", audioUrl: "img/FriendsPlus/Page10/Audio/17.mp3", },
        { url: "img/FriendsPlus/Page10/E1/21.jpg" },
        { url: "img/FriendsPlus/Page10/E1/22.jpg", audioUrl: "img/FriendsPlus/Page10/Audio/18.mp3", },
        { url: "img/FriendsPlus/Page10/E1/23.jpg" },
        { url: "img/FriendsPlus/Page10/E1/24.jpg", audioUrl: "img/FriendsPlus/Page10/Audio/19.mp3", },
        { url: "img/FriendsPlus/Page10/E1/25.jpg" },
        { url: "img/FriendsPlus/Page10/E1/26.jpg", audioUrl: "img/FriendsPlus/Page10/Audio/20.mp3", },
        { url: "img/FriendsPlus/Page10/E1/27.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page10/E1/28.jpg" }],
    ],
  },
  2: {
    // Exercise num
    unit: "Unit 1",
    id: "SB3-U1-P10-E2",
    audio: "img/FriendsPlus/Page10/Audio/audio-e2-p10.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        { url: "img/FriendsPlus/Page10/E2/1.jpg" },
        {
          url: "img/FriendsPlus/Page10/E2/2.jpg",
          audioUrl: "img/FriendsPlus/Page10/Audio/tieude-e2-p10.mp3",
        },
        { url: "img/FriendsPlus/Page10/E2/3.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page10/E2/4.jpg" }],
    ],
  },
  3: {
    // Exercise num
    unit: "Unit 1",
    id: "SB3-U1-P10-E3",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page10/E3/1.jpg" }]],
  },
};

export default json;
